import { languageCode } from '../config/localization.config';

/**
 * Use this for one of translations. Especially if you need it to run on the client.
 */
export const translateInline = (templates: { en: string; nl: string }) => {
	return templates[languageCode];
};
